// Tiny seeded RNG family used by Daily Run so that everyone playing the
// same UTC date sees the same procedurally generated tunnel.
//
// mulberry32 is a well-known fast 32-bit PRNG with good statistical
// properties for our use case (uniformity over short runs of a few
// hundred numbers per level). It is NOT cryptographically secure.

export type RngFn = () => number;

export function mulberry32(seed: number): RngFn {
  let a = seed >>> 0;
  return function (): number {
    a = (a + 0x6d2b79f5) | 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

// FNV-1a hash of a string -> 32-bit integer. Stable across browsers /
// platforms so the same date string always produces the same seed.
export function hashString32(input: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < input.length; i++) {
    h ^= input.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}

// Returns the current UTC date as "YYYY-MM-DD". Accepts an optional Date
// override to make tests deterministic.
export function dailyKey(date: Date = new Date()): string {
  const y = date.getUTCFullYear();
  const m = String(date.getUTCMonth() + 1).padStart(2, "0");
  const d = String(date.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function dailySeed(key: string): number {
  return hashString32(`morph-hex/${key}`);
}
